import { removeNulls } from 'utils/Object.utils';

type ReducerAction = {
  type?: string;
  [key: string]: any;
};

export type PropertyLoan = {
  id?: string;
  [key: string]: any;
};

export type PropertyLoansState = Record<string, any>;

const initialState: PropertyLoansState = {};

const propertyLoansReducer = (
  state: PropertyLoansState = initialState,
  action: ReducerAction
): PropertyLoansState => {
  switch (action.type) {
    case 'PROPERTY_LOAN_ADD': {
      const { loan } = action;
      return {
        ...state,
        [loan.id]: loan,
      };
    }
    case 'PROPERTY_LOAN_UPDATE': {
      const { loan } = action;
      return {
        ...state,
        [loan.id]: loan,
      };
    }
    case 'PROPERTY_LOAN_DELETE': {
      const { loanId } = action;
      return removeNulls({
        ...state,
        [loanId]: null,
      }) as PropertyLoansState;
    }
    default:
      return state;
  }
};
export default propertyLoansReducer;
